export const DEFAULT_PAGE_SIZE = 50;

// Server-side sort keys for GET /accounts/{uuid}/providers.
export const PROVIDERS_SORT = {
  nameAsc: 'name',
  nameDesc: '-name',
  createdAsc: 'createdTimestamp',
  createdDesc: '-createdTimestamp',
};

// Options for the legacy appointment-provider selects (claims edit,
// create-assessment). Per backend guidance the value SUBMITTED there is
// still the provider NAME string — only the option SOURCE moved to
// GET /providers. Duplicate names are collapsed (the submitted string
// would be identical anyway), and a current form value that is missing
// from the list (stale historical data) is prepended as its own option
// so the select can still display it.
export const buildAppointmentProviderOptions = (
  providers,
  currentValue,
  emptyLabel,
  // Marks the account's default for ONE context with a right-aligned
  // "Default" pill, so a preselected field explains itself instead of
  // looking like an arbitrary pick. `defaultFlag` is the list-payload
  // field for that context (isDefaultPdf / isDefaultClaims /
  // isDefaultSurveys); without both arguments nothing is marked.
  { defaultFlag, defaultTag } = {}
) => {
  const seen = new Set();
  const options = [];
  providers.forEach(provider => {
    if (!provider.name || seen.has(provider.name)) return;
    seen.add(provider.name);
    options.push({
      label: [provider.providerTitle, provider.name].filter(Boolean).join(' '),
      value: provider.name,
      ...(defaultFlag && defaultTag && provider[defaultFlag] ? { tag: defaultTag } : {}),
    });
  });
  if (currentValue && !seen.has(currentValue)) {
    options.unshift({ label: currentValue, value: currentValue });
  }
  if (emptyLabel) {
    options.unshift({ label: emptyLabel, value: '' });
  }
  return options;
};

// Filters travel as repeated `q=field:value` params (repeats are ANDed).
// The value part is plain URL-encoded — this endpoint does NOT use the
// base64 filter encoding some list endpoints do, and a literal ':' inside
// a value is unfilterable by contract. Sending the same field twice or an
// unknown field is a server-side 400, so each filter is emitted at most once.
export const buildProvidersListQuery = ({
  name,
  npi,
  isLinked,
  isDefault,
  sort,
  continuationToken,
  pageSize,
} = {}) => {
  const parts = [`pageSize=${pageSize || DEFAULT_PAGE_SIZE}`];
  if (name) parts.push(`q=name:${encodeURIComponent(name)}`);
  if (npi) parts.push(`q=providerNPINumber:${encodeURIComponent(npi)}`);
  if (isLinked === true || isLinked === false) parts.push(`q=isLinked:${isLinked}`);
  if (isDefault === true || isDefault === false) parts.push(`q=isDefault:${isDefault}`);
  if (sort) parts.push(`sort=${encodeURIComponent(sort)}`);
  if (continuationToken) parts.push(`continuation-token=${encodeURIComponent(continuationToken)}`);
  return parts.join('&');
};
